import React, { useEffect, useRef } from 'react'

/* Moves focus to the screen's main region on mount so screen readers and
   keyboard users land on the new content rather than back at the top of the
   document.

   preventScroll matters more than it looks: focusing an element scrolls it into
   view by default, which would fight the scroll reset ScreenShell performs on
   navigation. The reset itself lives in ScreenShell — content scrolls inside
   ScreenShell's region, not the window, so scrolling the window here would do
   nothing anyway. */
export const useFocusOnMount = <T extends HTMLElement>(): React.RefObject<T> => {
  const ref = useRef<T>(null)

  useEffect(() => {
    ref.current?.focus({ preventScroll: true })
  }, [])

  return ref
}
